// extracted by mini-css-extract-plugin
export default {"indicator":"MemorabiliaAlbumTab_indicator__WeWoC","arrow":"MemorabiliaAlbumTab_arrow__WK2D3"};